export default __webpack_public_path__ + "static/media/available_hover_cached_selected.b67351bf.svg";